import React, { ReactNode } from 'react';

import ModalContainer from 'app/components/ModalContainer';

interface WarningMsgProps {
  content: ReactNode;
  onCloseModal: () => void;
}

const WarningMsg: React.FC<WarningMsgProps> = props => {
  const { content, onCloseModal } = props;

  return (
    <ModalContainer
      isShow={!!content}
      onCloseDialog={onCloseModal}
      styleSlots={{
        modalContentStyle: {
          width: '90vw',
          maxWidth: '459px',
          height: 'auto',
        },
        iconWrapperStyle: {
          margin: 0,
        },
      }}
      maskClosable={false}
      modalProps={{
        destroyOnClose: true,
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ textAlign: 'center' }}
      >
        {content}
      </div>
    </ModalContainer>
  );
};

export default WarningMsg;
